
import { useEffect } from 'react';
import Header from './components/Header';
import ImageSlider from './components/ImageSlider';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Booking from './components/Booking';
import Footer from './components/Footer';

// SEO Component for home page
function HomeSEO() {
  useEffect(() => {
    // Update page title
    document.title = '岐阜県美濃加茂市洗車コーティング専門店 | Garage de carcare';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '岐阜県美濃加茂市の洗車コーティング専門店Garage de carcare。安く綺麗に、自宅ガレージで職人レベルの丁寧な施工。土日限定・完全予約制。研磨なしコース、軽研磨コース、２層コーティングコース、出張洗車サービス対応。');
    }

    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/`);
    }

    return () => {
      // No cleanup needed for home page as it uses existing meta tags
    };
  }, []);

  return null;
}

export default function HomePage() {
  return (
    <div className="min-h-screen animate-zoom-fade-in">
      <HomeSEO />
      <Header />
      <ImageSlider />
      <Services />
      <Gallery />
      <Booking />
      <Footer />
    </div>
  );
}
